import React from "react";
import { Loader, LoaderSizes, Pagination } from "@hid-galaxy-ui/galaxy-react";
import { useAppSelector } from "../../../../redux";
import { useAppDispatch } from "../../../../redux";
import { useEffect } from "react";
import { getGlobalLogsSagaAction } from "../../../../redux/saga/global-logs/saga-actions";
import moment from "moment";
import "./SystemLogs.scss";

const SystemLogs = () => {
  const dispatch = useAppDispatch();
  const [currentPageNumber, setCurrentPageNumber] = React.useState<number>(1);
  const { globalLogs, status } = useAppSelector((state) => state.global_logs);

  const pageSize = 10;
  const totalRecords = globalLogs.length;

  useEffect(() => {
    dispatch(getGlobalLogsSagaAction("mail"));
  }, [dispatch]);

  const handlePageChange = (clickedPageNumber: number | null) => {
    setCurrentPageNumber(clickedPageNumber);
  };

  const paginatedData = globalLogs.slice(
    (currentPageNumber - 1) * pageSize,
    currentPageNumber * pageSize
  );

  const formatDate = (dateString: string | null) => {
    if (!dateString) return "N/A";
    return moment(dateString).format("D MMMM YYYY");
  };

  const getStatusColor = (status: string) => {
    if (status === "true") return "success";
    if (status === "false") return "error";
    return "warning";
  };

  const getStatusText = (status: string) => {
    if (status === "true") return "Success";
    if (status === "false") return "Error";
    return status;
  };

  return (
    <div className="system-logs-page-container">
      <h1 className="page-title">Email Logs</h1>
      <div className="system-logs-container">
        {status.globalLogsLoading ? (
          <div className="loading">
            <Loader variant={LoaderSizes.large} />
          </div>
        ) : (
          <>
            <div className="table-container">
              <div className="table-header">
                <div className="col-1">Timestamp</div>
                <div className="col-2">Type</div>
                <div className="col-3">Message</div>
                <div className="col-4">Status</div>
              </div>

              {paginatedData.length > 0 ? (
                paginatedData.map((log, index) => {
                  return (
                    <div
                      className="table-row"
                      key={log.ID}
                      style={index === 0 ? { border: "none" } : {}}
                    >
                      <div className="col-1">{formatDate(log.created_at)}</div>
                      <div className="col-2">
                        {log.type.charAt(0).toUpperCase() + log.type.slice(1)}
                      </div>
                      <div className="col-3">{log.message}</div>
                      <div className="col-4">
                        <span
                          className={`status-badge status-${getStatusColor(
                            log.status
                          )}`}
                        >
                          {getStatusText(log.status)}
                        </span>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="no-data">
                  No logs available.
                </div>
              )}
            </div>
            {totalRecords > pageSize && (
              <div className="pagination-container">
                <Pagination
                  currentPageNumber={currentPageNumber}
                  totalRecords={totalRecords}
                  pageSize={pageSize}
                  border={true}
                  onPageNumberClick={handlePageChange}
                />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default SystemLogs;
